const GIFT_PACKAGES = {
  CLASSIC: ["gifting-packaging", "premium-gift-packaging", "chrome-jewelry-gift-box"],
  MTO: ["kps-chrome-jewelry-gift-box"],
};

export const GIFT_PACKAGES_HANDLES = Object.values(GIFT_PACKAGES).flat();

export default GIFT_PACKAGES;
